import { render, staticRenderFns } from "./ComponentRowMenu.vue?vue&type=template&id=edfb4df0&"
import script from "./ComponentRowMenu.vue?vue&type=script&lang=js&"
export * from "./ComponentRowMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports